import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PaymentSelector } from '../reducers/PaymentReducer';
import SignupPaymentAction from '../actions/SignupPaymentAction';
import ClickSubmitButton from '../../components/clickPayment/ClickSubmitButton';

const mapStateToProps = state => ({
  clickDetails: PaymentSelector.getClickDetails(state),
});


const mapDispatchToProps = dispatch =>
  bindActionCreators({
    storeClickGatewayDetails: SignupPaymentAction.storeClickGatewayDetails,
  }, dispatch);

const ClickSubmitButtonContainer = connect(mapStateToProps, mapDispatchToProps)(ClickSubmitButton);

export default ClickSubmitButtonContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/ClickSubmitButtonContainer.js
 **/